import axios from 'axios';
import { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

const BillFilterContainer = styled.div`
  display: flex;
  width: ${(props) =>
    props.$isMobile || props.$sidebar ? '100%' : 'auto'};

  @media (max-width: 768px) {
    display: ${(props) => (props.$isMobile ? 'flex' : 'none')};
  }
`;

const BillSelect = styled.div`
  width: ${(props) =>
    props.$isMobile || props.$sidebar ? '100%' : '9.375rem'};
`;

const selectStyles = {
  control: (base) => ({
    ...base,
    border: '1px solid #cccccc',
    borderRadius: '0.25rem',
    boxShadow: 'none',
    minHeight: '2rem',
    fontSize: '0.875rem',
    '&:hover': {
      border: '1px solid #cccccc',
    },
  }),
  // Hide the indicator separator (pipe)
  indicatorSeparator: () => ({
    display: 'none',
  }),
  // Style the placeholder text
  placeholder: (base) => ({
    ...base,
    color: '#212121',
  }),
  // Style the dropdown arrow (optional but helpful for consistent styling)
  dropdownIndicator: (base) => ({
    ...base,
    color: '#212121',
    padding: '0 0.5rem 0 0',
    '&:hover': {
      color: '#000000',
    },
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
};

export const BillFilter = ({
  originalStories,
  setFilteredStoriesByBill,
  setFilterActive,
  setSelectedBills,
  selectedBills,
  isMobile = false,
  isSidebar = false,
}) => {
  const [billOptions, setBillOptions] = useState([]);
  const selectRef = useRef(null);

  useEffect(() => {
    const fetchBills = async () => {
      try {
        const axiosT = axios.create({
          baseURL: `${process.env.REACT_APP_FEATURED_API}`,
          headers: {
            Authorization: `JWT ${localStorage.getItem('token')}`,
          },
        });

        const response = await axiosT.get(`bills/latest/`);
        if (response.data && response.data.bills) {
          setBillOptions(response.data.bills);
        }
      } catch (err) {
        console.log('Error fetching bills:', err);
      }
    };

    fetchBills();
  }, []);

  // Filter stories when selected bills change
  useEffect(() => {
    if (selectedBills.length > 0) {
      const filtered = originalStories.filter(
        (story) =>
          story.bid &&
          selectedBills.some((bill) => story.bid === bill.value)
      );
      setFilteredStoriesByBill(filtered);
      setFilterActive(true);
    } else {
      setFilterActive(false);
      setFilteredStoriesByBill([]);
    }
  }, [
    selectedBills,
    originalStories,
    setFilteredStoriesByBill,
    setFilterActive,
  ]);

  // Handler for bill selection
  const handleBillSelect = (selectedOption) => {
    if (!selectedOption) return;

    if (!selectedBills.some((bill) => bill.value === selectedOption.value)) {
      setSelectedBills([...selectedBills, selectedOption]);
    }

    if (selectRef.current) {
      selectRef.current.clearValue();
    }
  };

  return (
    <>
      <BillFilterContainer $isMobile={isMobile} $sidebar={isSidebar}>
        <BillSelect $isMobile={isMobile} $sidebar={isSidebar}>
          <Select
            ref={selectRef}
            options={billOptions}
            placeholder="Select bill ID"
            onChange={handleBillSelect}
            isClearable={true}
            value={null}
            styles={selectStyles}
          />
        </BillSelect>
      </BillFilterContainer>
    </>
  );
};
